module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "others4.843f10cd.jpg" + "?" + Date.now();